import React from 'react';

import ImgIconComp from './imgcomp';
import { WbDateYearFormat } from '../utils/common';
import { withTranslation } from 'react-i18next';

class DateRangeComp extends React.Component {
  constructor(props) {
    super(props);
    this.getSystemOffset = this.getSystemOffset.bind(this);
    this.getFormatDate = this.getFormatDate.bind(this);
    this.onCancel = this.onCancel.bind(this);
    this.onClear = this.onClear.bind(this);
    this.onChange = this.onChange.bind(this);
  }

  componentDidMount() {
    const _this = this;
    const { t } = this.props;
    let initialText = t('Select date range');
    const dateformat = this.props.date_format;
    let _startDate = this.props.start_date || 0;
    let _startDateString = this.props.start_date_string || _startDate;
    if (parseInt(_startDateString) > 0) {
      _startDateString = parseInt(_startDateString) * 1000 - this.getSystemOffset();
      _startDate = parseInt(_startDate) * 1000 - this.getSystemOffset();
      initialText = this.getFormatDate(_startDateString, dateformat);
    }
    let _endDate = this.props.end_date || null;
    let _endDateString = this.props.end_date_string || _endDate;
    if (parseInt(_endDateString) > 0) {
      _endDateString = parseInt(_endDateString) * 1000 - this.getSystemOffset();
      _endDate = parseInt(_endDate) * 1000 - this.getSystemOffset();
      initialText = `${initialText} - ${this.getFormatDate(_endDateString, dateformat)}`;
    }
    const { id, slideshowMode } = this.props;
    let datepickerElement = null;

    // not proud of this hack approach to solving a rendering issue with slideshow and datepicker
    // but will pull out this jquery-based datepicker and replace with a React version in next cycle

    // basic issue is that the slick-slider creates shadow copies of slide children to ensure left-right scrolling
    // remains smooth when end-of-children is reached and starts from beginning (or vice-versa)
    // but this creates a problem when using jquery selectors that only return first element matching that id (proper html wouldn't have more than one id etc)
    // so on the last slide, we're rendering datepicker to the shadow slide instead of the visible one 

    // applied a fix for this to graphs/highcharts where we render to the actual node that is displayed, 
    // rather than to a id string, but that's impractical in this component
    // so am using the id attribute to retrieve an array of matching elements for that id
    // then applying some potentially brittle logic to find the right one, only when within the slideshow context

    // TODO: pull this hack out when we replace datepicker for RBR/slideshow
    if (!slideshowMode) {
      datepickerElement = $(`#${id}`);
    } else {
      datepickerElement = $(this.props.refNode).closest('.rbr-multikrs-graph').find('.daterangecomp-text');
    }

    if (this.props.enableEvents) {
      $(datepickerElement).daterangepicker({
        presetRanges: [],
        applyOnMenuSelect: false,
        dateFormat: dateformat,
        initialText,
      });
    } else {
      $(datepickerElement).daterangepicker({
        presetRanges: [],
        applyOnMenuSelect: false,
        dateFormat: dateformat,
        initialText,
        datepickerOptions: {
          minDate: (_startDate) ? _this.isDSTdate(parseInt(_startDate)) : 0,
          maxDate: (_endDate) ? _this.isDSTdate(parseInt(_endDate)) : null,
          numberOfMonths: 2,
        },
        onChange(ele, range) {
          _this.onChange(ele, range);
        },
        onClear(ele) {
          _this.onClear(ele);
        },
      });
    }
    
    /* handle overflow */
    const legendsHeight = $(`.rbr-multikrs-wrapper[data-id="${this.props.item.id}"] .rbr-multikrs-legends-wrapper`).height();
    if ($('.rbr-multikrs-wrapper').length > 0 && legendsHeight > 32) { // height per row is 16px, we limit max 2 rows for legneds
      $(`.rbr-multikrs-wrapper[data-id="${this.props.item.id}"] .rbr-multikrs-legends-wrapper .rbr-multikrs-legend`).each(function () {
        $(this).addClass('truncateText');
        // if the text doesn't overflow, don't add '...'
        if ($(this).children('.rbr-multikr-legend-name').width() < 80) {
          $(this).addClass('short-text');
        }
      });
    }
  }

  isDSTdate(date, returnValue = false) {
    let utcDate = moment.utc(date);
    const isDst = moment().isDST();
    if (isDst) {
      utcDate = utcDate.clone().add(1, 'hour');
    }
    if (returnValue) {
      return utcDate.valueOf();
    }
    return new Date(utcDate.valueOf());
  }

  getSystemOffset() {
    return WbDateYearFormat.getSystemOffset();
  }

  getFormatDate(date, dateformat) {
    const utcDate = this.isDSTdate(date, true);
    return moment(utcDate).format('MMM DD, YYYY');
  }

  onCancel() {}

  onClear(ele) {
    if (typeof this.props.onClear === 'function') {
      this.props.onClear.apply(null, [ele, this.props]);
    }
  }

  onChange(ele, range) {
    if (typeof range === 'object') {
      if (typeof this.props.onChange === 'function') {
        this.props.onChange.apply(null, [ele, range, this.props]);
      }
    }
  }

  render() {
    const { id, slideshowMode } = this.props;
    const wrapperClass = this.props.class || '';

    return (
      <div className={`daterangecomp-wrapper ${wrapperClass}`} style={this.props.style || {}}>
        <div className="daterangecomp-dp">
          <div className="daterangecomp-text-wrapper">
            <input
              name="datepicker_goalchart[]"
              id={id}
              className="daterangecomp-text"
              disabled={!this.props.enableEvents}
              type="hidden"
            />
          </div>
          <div className="daterangecomp-arrow">
            <ImgIconComp id="cal_arrow_down" width="10" height="7" style={slideshowMode ? { marginTop: '3px', border: 'none' } : { marginTop: '3px' }} />
          </div>
        </div>
      </div>
    );
  }
}

DateRangeComp.defaultProps = {
  date_format: 'M dd, yy',
  start_date: 0,
  end_date: null,
};

export default withTranslation()(DateRangeComp);
